var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M26.957 16.161v-3.515c0-4.681-2.54-8.756-6.31-10.955v3.17c0 .583-.472 1.055-1.055 1.055s-1.056-.472-1.056-1.055V.708C17.503.338 16.412.09 15.275 0c.013.066.04.127.04.196v7.067c0 .583-.473 1.056-1.056 1.056-.583 0-1.055-.473-1.055-1.056V.196c0-.069.027-.13.039-.196-1.207.096-2.365.362-3.454.771v4.09c0 .583-.473 1.055-1.056 1.055-.583 0-1.055-.472-1.055-1.055V1.798C4.012 4.022 1.562 8.045 1.562 12.646v3.515h25.395zM28.519 22.028H0v-2.405c0-1.33 1.077-2.406 2.405-2.406h23.708c1.329 0 2.406 1.077 2.406 2.406v2.405z",
    transform: "translate(.281 .977)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M17.83 16.052c0 1.972-1.599 3.57-3.57 3.57-1.973 0-3.57-1.598-3.57-3.57 0-1.972 1.597-3.57 3.57-3.57 1.971 0 3.57 1.598 3.57 3.57",
    transform: "translate(.281 .977)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.2daa0c3dd35044232f765a28da12815c.svg";
export { ForwardRef as ReactComponent };